var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales"},[_c('div',{staticClass:"content"},[_c('div',[_c('distribution',{attrs:{"sales_data":_vm.sales_data}}),_vm._v(" "),_c('distribution-ranking',{attrs:{"sales_data":_vm.sales_data}}),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})],1),_vm._v(" "),_c('sales-trend'),_vm._v(" "),_c('sales-table')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4445714c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/data-analysis/sales/sales.vue
// module id = null
// module chunks = 